import { Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { C3Text } from "../text/CustomText";
import { useEffect, useRef, useState } from "react";
import { useClickOutside } from "../../hooks/useClickOutside";
import { createPortal } from "react-dom";
import CustomPopup from "../popup/CustomPopup";
import { FixedPositionDropdownWrapper } from "./CustomDropdownWrapper";
import { Theme } from "../../Theme";
import FranchiseService from "../../../service/FranchiseService";

const DROPDOWN_WIDTH = 160;

export function FranchiseActionDropdownMenu({
    onClose,
    anchorEl,
    placement = "bottom-end",
    dto,
    setDto,
    setOpenEditModal,
    onDelete,
}) {
    const service = new FranchiseService();
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const menuRef = useRef(null);

    useClickOutside(menuRef, (event) => {
        if (anchorEl && anchorEl.contains(event.target)) {
            return;
        }
        if (onClose) onClose();
    });

    useEffect(() => {
        if (anchorEl) {
            const rect = anchorEl.getBoundingClientRect();
            let leftPos;

            if (placement === "bottom-end") {
                leftPos = rect.right - DROPDOWN_WIDTH;
            } else {
                leftPos = rect.left;
            }

            setPosition({
                top: rect.bottom + window.scrollY + 8,
                left: leftPos + window.scrollX,
            });
        }
    }, [anchorEl, placement]);

    // delete confirm popup
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);

    const handleDelete = () => {
        service.deleteFranchise({ idFranchise: dto.idFranchise }).then(() => {
            onDelete?.();
            onClose();
        });
    };

    const dropdownContent = (
        <FixedPositionDropdownWrapper $top={position.top} $left={position.left} ref={menuRef} $width={DROPDOWN_WIDTH}>
            <SizedBox
                width={"100%"}
                height={"auto"}
                hoverBackgroundColor={Theme.color.zinc150}
                padding={"0 10px"}
                borderRadius={"4px"}
                onClick={() => {
                    setDto(dto);
                    setOpenEditModal(true);
                    if (onClose) onClose();
                }}
                cursor={"pointer"}
            >
                <Row width={"100%"} justifyContent={"flex-start"} padding={"8px 10px"} cursor={"pointer"}>
                    <CustomIcon iconName={"edit"} size={"18px"} />
                    <SizedBox width={"10px"} />
                    <C3Text fontColor={Theme.color.zinc850}>Edit</C3Text>
                </Row>
            </SizedBox>
            <SizedBox
                width={"100%"}
                height={"auto"}
                hoverBackgroundColor={Theme.color.zinc150}
                padding={"0 10px"}
                borderRadius={"4px"}
                onClick={() => setOpenDeleteConfirm(true)}
                cursor={"pointer"}
            >
                <Row width={"100%"} justifyContent={"flex-start"} padding={"8px 10px"} cursor={"pointer"}>
                    <CustomIcon iconName={"trash_red"} size={"18px"} />
                    <SizedBox width={"10px"} />
                    <C3Text fontColor={Theme.color.zinc850}>Delete</C3Text>
                </Row>
            </SizedBox>
            <CustomPopup
                onClose={() => setOpenDeleteConfirm(false)}
                isOpen={openDeleteConfirm}
                onConfirm={handleDelete}
                message={"Are you sure you want to delete this franchise?"}
            />
        </FixedPositionDropdownWrapper>
    );

    return createPortal(dropdownContent, document.body);
}
